import BaseUtil from "../../util/BaseUtil";
import BusinessConstants from "../../constant/BusinessConstants";
import dayjs from "dayjs";

const type = `@@ActionType/UPDATE@${__filename}`;

const types = BusinessConstants.EMPLOYEE_ITEM_GROUP_TYPE;

export const trainTypeArray = [
    {
        key: types.TRAIN.code,
        value: "培训",
    },
    {
        key: types.TRAIN_METHOD.code,
        value: "理论考核",
    },
    {
        key: types.TRAIN_OPERATION.code,
        value: "技术操作考核",
    }
];

const dictKeyMap = {
    [types.TRAIN.code]: "TRAIN_CATEGORY",
    [types.TRAIN_METHOD.code]: "TRAIN_METHOD_CONTENT_TYPE",
    [types.TRAIN_OPERATION.code]: "TRAIN_OPERATION",
}

export const TrainTestResult = {
    pass: "PASS",
    fail: "FAIL",
}

export const TrainLevelType = {
    hospital: "HOSPITAL",
    unit: "UNIT",
}

export const trainTestLabelMap = {
    [TrainTestResult.fail]: "不合格",
    [TrainTestResult.pass]: "合格",
}

export const trainLevelTypeLabelMap = {
    [TrainLevelType.unit]: "科室",
    [TrainLevelType.hospital]: "院级",
}

const initState = {
    groupEnabledFinding: true, // 字段组开启状况
    trainTypeArray: trainTypeArray,
    selectedTrainType: null, // 选中的考核类型
    data: null, // 表格数据
    selectedUnitIds: null, // 选中的科室
    itemsByCode: null, // 字段
    items: null, // 字段
    dicts: null, // 培训内容字典
    selectedContent: null, // 选中的培训内容

    selectedYear: dayjs(),
    keyword: "", // 搜索关键词
    initializing: true, // 初始化（字段请求）
    tableLoading: false, // 数据加载
    pageable: {
        limit: 30,
        current: 1, // 分页
    },

    importModalVisible: false, // 导入Modal
    editModalVisible: false, // 编辑Modal
    editData: null, // 编辑中的数据
    confirmLoading: false, // 确认中

    editOptionData: null, // 编辑选项
    editOptionModalLoading: false, // 编辑选项loading
    editOptionModalVisible: false, // 编辑选项显隐
}

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,

    dictKeyMap,
};
export default viewModel;
